export enum JobApplicationStates {
  LOADING_JOB_POST,
  JOB_POST_LOADED,
  JOB_POST_FAILED,
  APPLYING,
  APPLICATION_FAILED,
  APPLICATION_SUCCEEDED
}
